import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Box } from '@mui/material';
import Grid from '@mui/material/Grid2';

import { useFetchAllDevices } from '../queries';

import { setSearch } from 'reducers/deviceDashboard';
import { CentsDataGridServer } from 'components/common/dataGrid/dataGridServer';
import TableSearchBar from 'components/common/search/TableSearchBar';

const renderLink = ({ row, displayKey = 'device' }) => (
  <Link to={`/devices/${row.id}`}>{row[displayKey]}</Link>
);

const COLUMNS = [
  { headerName: 'Id', field: 'id', flex: 0.4 },
  { headerName: 'Business', field: 'businessName', flex: 1 },
  { headerName: 'Store', field: 'storeName', flex: 1 },
  { headerName: 'Status', field: 'status', flex: 0.5 },
  {
    headerName: 'MAC Address',
    field: 'mac',
    flex: 1,
    renderCell: (props) => renderLink({ ...props, displayKey: 'mac' }),
  },
  { headerName: 'Simulated', field: 'simulated', flex: 0.5 },
];

const DEFAULT_PAGE_SIZE = 20;

const DeviceTable = () => {
  const {
    searchTerm: searchString,
  } = useSelector((state) => state.deviceDashboard.filters);
  const dispatch = useDispatch();

  const [pageNumber, setPageNumber] = useState(0);

  const { data: devicesList, isLoading } = useFetchAllDevices(
    pageNumber,
    searchString,
  );

  const { devices, total } = devicesList ?? {};

  const handlePageChange = ({ page }) => {
    setPageNumber(page);
  };

  const handleSearch = (searchInput) => {
    if (searchInput?.length > 0) {
      if (searchInput !== searchString) {
        setPageNumber(0);
      }
    } else {
      setPageNumber(0);
    }
    dispatch(setSearch(searchInput || ''));
  };

  return (
    <div className="page-container">
      <div className="devices-header">
        <h1>Device dashboard</h1>
      </div>
      <Grid container spacing={3} alignItems="center">
        <Grid size={{ xs: 6 }}>
          <Box sx={{ marginTop: '17px' }}>
            <TableSearchBar
              placeholder="Search devices by MAC address, store name, or business name"
              onSearch={handleSearch}
              value={searchString}
            />
          </Box>
        </Grid>
      </Grid>
      <CentsDataGridServer
        tableName="DEVICE-DASHBOARD"
        data={devices ?? []}
        columns={COLUMNS}
        isLoading={isLoading}
        rowCount={total ?? 0}
        pageSize={DEFAULT_PAGE_SIZE}
        page={pageNumber}
        onPageChange={handlePageChange}
      />
    </div>
  );
};

export default DeviceTable;
